
export type EnrollCourse201OneOfFiveResult = typeof EnrollCourse201OneOfFiveResult[keyof typeof EnrollCourse201OneOfFiveResult];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrollCourse201OneOfFiveResult = {
  waitlisted: 'waitlisted',
} as const;
